import { components } from 'react-select';
import IconHandler from 'components/common/icon/IconHandler';
import { Box, Tooltip } from '@mui/material';
import React from 'react';

// Default template for MultiValue, override with props.optionComponent
export const ReactSelectMultiValue = (props: any) => {
    return (
        <>
            <components.MultiValue {...props}>
                <>
                    {props.data.props?.icon && (
                        <Box
                            sx={{
                                mr: 0.5,
                                width: '16px',
                                height: '16px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                verticalAlign: 'middle',
                                '.svg-icon-mi': { fontSize: '16px' },
                                '.svg-inline--fa': { fontSize: '14px' },
                                img: {
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                },
                            }}
                        >
                            <IconHandler icon={props.data.props?.icon} />
                        </Box>
                    )}
                    {props.data.props?.tooltip ? (
                        <Tooltip title={props.data.props?.tooltip}>{props.children}</Tooltip>
                    ) : (
                        props.children
                    )}
                </>
            </components.MultiValue>
        </>
    );
};
